import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
import ModalPortal from '../../../../../components/modal-portal';
import { SimpleModal } from '../../../../../components/simple-modal';

/**
 * @param {object} props
 * @param {() => void} props.onClose
 * @param {() => void} props.onConfirm
 * @returns {JSX.Element}
 */
export const DeleteShopperConfirmation = ({ onClose, onConfirm }) => {
  return (
    <ModalPortal onClose={onClose}>
      <SimpleModal
        actionMessage={messages.confirmDeletionButtonText}
        cancelMessage={messages.cancelDeletionButtonText}
        headerMessage={messages.deleteShopperConfirmationHeaderText}
        onAction={onConfirm}
        onClose={onClose}
      >
        <Text textType={TextType.Description} value={messages.deleteShopperConfirmationBodyText} />
      </SimpleModal>
    </ModalPortal>
  );
};
